import {
  Alert,
} from 'react-native';

export default class Hermes {
  static async fetch(url, options) {
    options.credentials = 'include';
    const response = await fetch(url, options);
    const result = await response.json();
    if (result.error) {
      throw result.error;
    }
    return result;
  }
  static alert(error) {
    Alert.alert(JSON.stringify(error));
  }
  static log(error) {
    console.log(JSON.stringify(error));
  }
}
